import "slick-carousel";

export const useCaseSlider = function ($block) {
  $(".block-use-case-slider__slides").not(".slick-initialized").slick({
    prevArrow:
      '<a href="#" class="block-use-case-slider__arrow block-use-case-slider__arrow-left"><i class="fa-regular fa-arrow-left"></i></a>',
    nextArrow:
      '<a href="#" class="block-use-case-slider__arrow block-use-case-slider__arrow-right"><i class="fa-regular fa-arrow-right"></i></a>',
    fade: true,
    dots: true,
    adaptiveHeight: true,
  });
};
